import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

export const routes: Routes = [
    {
        path: '',
        pathMatch: 'full',
        loadChildren: () =>
            import('src/modules/realtime-data-map/realtime-data-map-routing.module').then(
                (m) => m.RealtimeDataMapRoutingModule
            )
    },
    {
        path: 'realtime-data-map',
        loadChildren: () =>
            import('src/modules/realtime-data-map/realtime-data-map-routing.module').then(
                (m) => m.RealtimeDataMapRoutingModule
            )
    },
    {
        path: 'no-parking-zones',
        loadChildren: () =>
            import('src/modules/no-parking-zones/no-parking-zones-routing.module').then(
                (m) => m.NoParkingZonesRoutingModule
            )
    },
    {
        path: 'mobility-hubs',
        loadChildren: () =>
            import('src/modules/mobility-hubs/mobility-hubs-routing.module').then((m) => m.MobilityHubsRoutingModule)
    },
    {
        path: '**',
        redirectTo: '/realtime-data-map'
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {}
